import { render, staticRenderFns } from "./BlogEditor.vue?vue&type=template&id=bc5f701e&scoped=true&"
import script from "./BlogEditor.vue?vue&type=script&lang=js&"
export * from "./BlogEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlogEditor.vue?vue&type=style&index=0&id=bc5f701e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f701e",
  null
  
)

export default component.exports